// extracted by mini-css-extract-plugin
export default {"root":"iDpbYGpzbcIShmQG_1ub","container":"CJUnLFK7CkQIsMKyf0py"};